import { render, staticRenderFns } from "./detailCom.vue?vue&type=template&id=18da979a&scoped=true&"
import script from "./detailCom.vue?vue&type=script&lang=js&"
export * from "./detailCom.vue?vue&type=script&lang=js&"
import style0 from "./detailCom.vue?vue&type=style&index=0&id=18da979a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18da979a",
  null
  
)

export default component.exports